export enum ScreeningStatus {
  Scheduled = 'scheduled',
  InProgress = 'in_progress',
  Completed = 'completed',
  AnalysisTriggered = 'analysis_triggered',
  AnalysisCompleted = 'analysis_completed',
  Expired = 'expired'
}

export const isScreeningCompleted = (status: ScreeningStatus) => {
  return (
    status === ScreeningStatus.Completed ||
    status === ScreeningStatus.AnalysisCompleted ||
    status === ScreeningStatus.AnalysisTriggered
  );
};

export const getScreeningStatusText = (status: ScreeningStatus) => {
  switch (status) {
    case ScreeningStatus.Scheduled:
      return 'Scheduled';
    case ScreeningStatus.Completed:
    case ScreeningStatus.AnalysisTriggered:
    case ScreeningStatus.InProgress:
      return 'In Progress';
    case ScreeningStatus.AnalysisCompleted:
      return 'Completed';
    case ScreeningStatus.Expired:
      return 'Expired';
    default:
      return status;
  }
};

export const getScreeningStatusFilterList = () => {
  return [
    ScreeningStatus.Scheduled,
    ScreeningStatus.InProgress,
    ScreeningStatus.AnalysisCompleted,
    ScreeningStatus.Expired
  ];
};

export const expandScreeningStatus = (status: ScreeningStatus) => {
  switch (status) {
    case ScreeningStatus.Scheduled:
      return [ScreeningStatus.Scheduled];
    case ScreeningStatus.InProgress:
      return [
        ScreeningStatus.InProgress,
        ScreeningStatus.Completed,
        ScreeningStatus.AnalysisTriggered
      ];
    case ScreeningStatus.Completed:
      return [
        ScreeningStatus.InProgress,
        ScreeningStatus.Completed,
        ScreeningStatus.AnalysisTriggered
      ];
    case ScreeningStatus.AnalysisTriggered:
      return [
        ScreeningStatus.InProgress,
        ScreeningStatus.Completed,
        ScreeningStatus.AnalysisTriggered
      ];
    case ScreeningStatus.AnalysisCompleted:
      return [ScreeningStatus.AnalysisCompleted];
    case ScreeningStatus.Expired:
      return [ScreeningStatus.Expired];
    default:
      return status;
  }
};
